// extracted by mini-css-extract-plugin
export default {"container":"y71r2dbV9qArAcEhBZgh","image":"ISh0lv9ZZYhpjEaMBKP_","title":"COW0IFwZ7khEYJaAPscQ","subtitle":"fLPYwOpgadOfVunI3xHr","buttonContainer":"IjcxHbRkXCVDdgu99KOk"};